'use client';

import { useState } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ToolSection from './components/ToolSection';
import FormatSupportSection from './components/FormatSupportSection';
import FAQSection from './components/FAQSection';
import FooterSection from './components/FooterSection';

export default function AudioExtractorInterfacePage() {
  const [activeTool, setActiveTool] = useState<'extractor' | 'remover'>('extractor');

  const handleToolSwitch = (tool: 'extractor' | 'remover') => {
    setActiveTool(tool);
    // Smooth scroll to tool section when switching from nav
    const toolSection = document.querySelector('#tool');
    if (toolSection) {
      setTimeout(() => {
        toolSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 50);
    }
  };

  return (
    <div data-component-id="src/app/audio-extractor-interface/page.tsx:26:4" data-component-path="src/app/audio-extractor-interface/page.tsx" data-component-line="26" data-component-end-line="44" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22min-h-screen%20bg-hero-pattern%22%7D" className="min-h-screen bg-hero-pattern">
      {/* Sticky Header with Navigation */}
      <Header data-component-id="src/app/audio-extractor-interface/page.tsx:28:6" data-component-path="src/app/audio-extractor-interface/page.tsx" data-component-line="28" data-component-end-line="28" data-component-file="page.tsx" data-component-name="Header" data-component-content="%7B%22elementName%22%3A%22Header%22%7D" activeTool={activeTool} onToolSwitch={handleToolSwitch} />

      {/* Hero + Tool Switcher */}
      <HeroSection data-component-id="src/app/audio-extractor-interface/page.tsx:31:6" data-component-path="src/app/audio-extractor-interface/page.tsx" data-component-line="31" data-component-end-line="31" data-component-file="page.tsx" data-component-name="HeroSection" data-component-content="%7B%22elementName%22%3A%22HeroSection%22%7D" activeTool={activeTool} onToolSwitch={handleToolSwitch} />

      {/* Main Tool Interface */}
      <ToolSection data-component-id="src/app/audio-extractor-interface/page.tsx:34:6" data-component-path="src/app/audio-extractor-interface/page.tsx" data-component-line="34" data-component-end-line="34" data-component-file="page.tsx" data-component-name="ToolSection" data-component-content="%7B%22elementName%22%3A%22ToolSection%22%7D" activeTool={activeTool} />

      {/* Format Support Reference */}
      <FormatSupportSection data-component-id="src/app/audio-extractor-interface/page.tsx:37:6" data-component-path="src/app/audio-extractor-interface/page.tsx" data-component-line="37" data-component-end-line="37" data-component-file="page.tsx" data-component-name="FormatSupportSection" data-component-content="%7B%22elementName%22%3A%22FormatSupportSection%22%7D" />

      {/* FAQ Accordion */}
      <FAQSection data-component-id="src/app/audio-extractor-interface/page.tsx:40:6" data-component-path="src/app/audio-extractor-interface/page.tsx" data-component-line="40" data-component-end-line="40" data-component-file="page.tsx" data-component-name="FAQSection" data-component-content="%7B%22elementName%22%3A%22FAQSection%22%7D" />

      {/* Footer */}
      <FooterSection data-component-id="src/app/audio-extractor-interface/page.tsx:43:6" data-component-path="src/app/audio-extractor-interface/page.tsx" data-component-line="43" data-component-end-line="43" data-component-file="page.tsx" data-component-name="FooterSection" data-component-content="%7B%22elementName%22%3A%22FooterSection%22%7D" />
    </div>
  );
}
